export default "__VITE_ASSET__BBAoRzp___"